(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["protec-buybar"] && !Shopify.designMode) return;
  try {
    (function () {
    var bar = document.querySelector('[data-pr-buybar]');
    if (!bar) return;
    var reduceBB = !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
    var trigger = document.querySelector('[data-pr-buybar-after]') || document.querySelector('h1');
    var shown = false;
    var ticking = false;
    function update() {
      ticking = false;
      var b = trigger ? trigger.getBoundingClientRect().bottom : (600 - window.scrollY);
      var past = shown ? b < 40 : b < -40;
      var nearFoot = (window.innerHeight + window.scrollY) > (document.body.offsetHeight - 160);
      var want = past && !nearFoot;
      if (want === shown) return;
      shown = want;
      bar.classList.toggle('is-shown', want);
      bar.setAttribute('aria-hidden', want ? 'false' : 'true');
    }
    function onScroll() {
      if (!ticking) { ticking = true; requestAnimationFrame(update); }
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
    update();

    /* ---- configurator mode (opt-in via data-pr-configurable). Backwards-compatible: on PDPs that
       do not pass configurable:true this whole block is inert (attribute absent -> cfgItems stays
       null -> Buy Now uses the original single-variant path). ---- */
    var configurable = bar.hasAttribute('data-pr-configurable');
    var cfgItems = null;
    if (configurable) {
      var drawer = bar.querySelector('[data-pr-drawer]');
      var expand = bar.querySelector('[data-pr-expand]');
      if (expand && drawer) {
        drawer.hidden = false;               // in the DOM but collapsed; open/close animates via .is-open
        drawer.classList.remove('is-open');
        expand.addEventListener('click', function () {
          var open = expand.getAttribute('aria-expanded') === 'true';
          expand.setAttribute('aria-expanded', open ? 'false' : 'true');
          drawer.classList.toggle('is-open', !open);
          bar.classList.toggle('is-open', !open);
        });
      }
      var totalEl = bar.querySelector('[data-pr-total]');
      var financeEl = bar.querySelector('[data-pr-finance]');
      /* rAF money tween: whole pounds in flight (tabular-nums holds width), exact pennies at rest. */
      function tweenText(el, toCents, restLabel) {
        if (!el) return;
        if (reduceBB) { el.textContent = restLabel; el._c = toCents; return; }
        var from = (typeof el._c === 'number') ? el._c : toCents;
        var had = (typeof el._c === 'number');
        el._c = toCents;
        if (!had || from === toCents) { el.textContent = restLabel; return; }
        var prefix = (String(restLabel).match(/^[^\d-]*/) || [''])[0];
        if (el._raf) cancelAnimationFrame(el._raf);
        var start = null;
        function frame(t) {
          if (start === null) start = t;
          var p = Math.min((t - start) / 350, 1);
          var e2 = 1 - Math.pow(1 - p, 3);
          var cur = Math.round(from + (toCents - from) * e2);
          if (p < 1) { el.textContent = prefix + Math.round(cur / 100).toLocaleString('en-GB'); el._raf = requestAnimationFrame(frame); }
          else { el.textContent = restLabel; el._raf = null; }
        }
        el._raf = requestAnimationFrame(frame);
      }
      function bump(el) {
        if (!el || reduceBB) return;
        el.classList.remove('pr-bump'); void el.offsetWidth; el.classList.add('pr-bump');
      }
      document.addEventListener('protec:config-change', function (e) {
        var d = e.detail || {};
        cfgItems = (d.items && d.items.length) ? d.items : null;
        var changed = totalEl && typeof d.totalCents === 'number' && typeof totalEl._c === 'number' && totalEl._c !== d.totalCents;
        if (totalEl && typeof d.totalCents === 'number') tweenText(totalEl, d.totalCents, d.totalLabel || totalEl.textContent);
        else if (totalEl && d.totalLabel) totalEl.textContent = d.totalLabel;
        /* the finance metric is a protec-finance-line rendered with sync: 'config'; its own
           listener (window.ProtecFinline) recomputes it from d.totalCents. Nothing to do here. */
        if (financeEl && d.financeHref) financeEl.setAttribute('href', d.financeHref);
        if (changed) bump(totalEl.closest ? totalEl.closest('.pr-buybar__v') : totalEl.parentNode);
      });
    }

    var bn = bar.querySelector('[data-pr-buynow]');
    if (bn) {
      var bnLabel = bn.innerHTML;
      bn.addEventListener('click', function () {
        if (bn.disabled) return;
        bn.disabled = true;
        /* configurator-only: flip to a busy state so a slow add can't be double-fired. Non-cfg
           PDPs (PROBOOTS) keep the original behaviour: the button just disables. */
        if (configurable) {
          bn.setAttribute('aria-busy', 'true');
          bn.innerHTML = '<span class="pr-spin" aria-hidden="true"></span>Adding…';
        }
        var done = function () { window.location.href = '/checkout'; };
        var fail = function () {
          bn.disabled = false;
          if (configurable) { bn.removeAttribute('aria-busy'); bn.innerHTML = bnLabel; }
        };
        /* configurator: add the whole package (main variant x qty + accessories) in one call */
        if (configurable && cfgItems && cfgItems.length) {
          fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ items: cfgItems })
          }).then(done).catch(fail);
          return;
        }
        /* default single-variant path (unchanged) */
        var inPage = document.querySelector('form[action*="/cart/add"] [name="id"]');
        var vid = (inPage && inPage.value) || bn.getAttribute('data-variant-id');
        if (!vid) { bn.disabled = false; return; }
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: vid, quantity: 1 })
        }).then(done).catch(fail);
      });
    }
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["protec-finance-line"] && !Shopify.designMode) return;
  try {
    /* window.ProtecFinline: the ONE client-side mirror of the finance-line thresholds.
     Reads its config off the element's data attributes (emitted by the Liquid above),
     so the constants still have a single home. */
  (function () {
    if (window.ProtecFinline) return;
    function fmt(pence) {
      var pounds = pence / 100;
      var opts = pence % 100 === 0
        ? { maximumFractionDigits: 0 }
        : { minimumFractionDigits: 2, maximumFractionDigits: 2 };
      return '£' + pounds.toLocaleString('en-GB', opts);
    }
    function textFor(el, pence) {
      var max3 = parseInt(el.getAttribute('data-fl-max3'), 10) || 0;
      var term = parseInt(el.getAttribute('data-fl-term'), 10) || 12;
      var humm = el.getAttribute('data-fl-humm') === '1';
      var full = el.getAttribute('data-fl-style') === 'full';
      if (el.getAttribute('data-fl-plan') === 'over') {
        var perMo = Math.round(pence / term);
        return full
          ? 'Pay ' + fmt(perMo) + ' over ' + term + ' months with Klarna or humm.'
          : fmt(perMo) + '/mo';
      }
      if (pence <= max3) {
        var third = Math.ceil(pence / 3);
        return full
          ? 'Or 3 interest-free payments of ' + fmt(third) + ' with Klarna.'
          : '3 × ' + fmt(third);
      }
      var mo = Math.round(Math.floor(pence / term) / 100) * 100;
      if (!full) return 'From ' + fmt(mo) + '/mo';
      return humm
        ? 'From ' + fmt(mo) + ' per month over ' + term + ' months with humm.'
        : 'From ' + fmt(mo) + ' per month with finance.';
    }
    function update(el, pence) {
      if (!el || !isFinite(pence) || pence <= 0) return;
      var min3 = parseInt(el.getAttribute('data-fl-min3'), 10) || 0;
      el.setAttribute('data-fl-pence', String(pence));
      el.style.display = pence < min3 ? 'none' : '';
      var t = el.querySelector('[data-fl-text]');
      if (t) t.textContent = pence < min3 ? '' : textFor(el, pence);
    }
    function updateAll(root, pence) {
      [].slice.call((root || document).querySelectorAll('[data-pr-finline]:not([data-fl-sync])'))
        .forEach(function (el) { update(el, pence); });
    }
    window.ProtecFinline = { update: update, updateAll: updateAll };
    /* CryoLink configurator re-totals: refresh every instance rendered with sync: 'config' */
    document.addEventListener('protec:config-change', function (e) {
      var d = e.detail || {};
      if (typeof d.totalCents !== 'number') return;
      [].slice.call(document.querySelectorAll('[data-pr-finline][data-fl-sync="config"]'))
        .forEach(function (el) { update(el, d.totalCents); });
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
